module.exports = __webpack_public_path__ + "assets/chevron-up.b7c235ea.svg";